import { CommandRequest } from './command-request';

export class SendCommandRequest {
  public commandRequest: CommandRequest;
  public vehicles: Array<number>;
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/send-command-request.ts